import { useQuery } from '~/common/routerUtils';

// two options
import ContactsList from './Contacts';
import ContactDetails from './contactDetails';

export default function Contacts() {
  const query = useQuery();
  const contactId = query.get('contactId');

  if (contactId) {
    return <ContactDetails />;
  }

  return <ContactsList />;
}
